import {createSlice} from "@reduxjs/toolkit"

const initialState = {
    urlLink: localStorage.getItem("urlLink") ? JSON.parse(localStorage.getItem("urlLink")) : null,
    loading: false,
};

const urlSlice = createSlice({
    name:"url",
    initialState: initialState,
    reducers: {
        setUrl(state, value) {
            state.urlLink = value.payload;
        },
        setLoading(state, value) {
            state.loading = value.payload;
          },
    },
});

export const {setUrl, setLoading} = urlSlice.actions;
export default urlSlice.reducer;